import React, { useEffect } from "react";
import PropTypes from "prop-types";
import useLocalQuery, {
  Table,
  NonSortableHeader
} from "hooks/useQuery/local-query";
import { formatDate } from "utils/dates";

const PatientSearchResults = ({
  multiple,
  patients,
  isFetching,
  selectedPatients,
  setSelectedPatients,
  pagination,
  setPagination,
  count
}) => {
  const { query, queryDispatcher } = useLocalQuery(patients, { pagination });

  useEffect(() => {
    if (pagination.page != query.pagination.page)
      setPagination({ ...pagination, page: query.pagination.page });

    if (pagination.per != query.pagination.per)
      setPagination({ page: 1, per: query.pagination.per });
  }, [query]);

  return (
    <Table
      isFetching={isFetching}
      containerClass="query-table patient-search-results-table"
      scrollable
      usePagination={true}
      TableRow={({
        patient_name,
        email,
        company_name,
        date_of_birth,
        account_number,
        user_id
      }) => (
        <tr
          onClick={() => {
            if (multiple) {
              if (selectedPatients.includes(user_id)) {
                setSelectedPatients(
                  selectedPatients.filter(id => id !== user_id)
                );
              } else {
                setSelectedPatients([...selectedPatients, user_id]);
              }
            } else {
              if (selectedPatients === user_id) {
                setSelectedPatients("");
              } else {
                setSelectedPatients(user_id);
              }
            }
          }}
        >
          <td>
            <input
              type="checkbox"
              checked={
                multiple
                  ? selectedPatients.includes(user_id)
                  : selectedPatients === user_id
              }
              readOnly
            />
          </td>
          <td>{patient_name}</td>
          <td
            style={{
              maxWidth: 120,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {email}
          </td>
          <td>{formatDate(date_of_birth)}</td>
          <td>{account_number}</td>
          <td>{company_name}</td>
        </tr>
      )}
      columns={[
        {
          header: "All",
          field: "controls",
          Cell: () => (
            <NonSortableHeader
              text="All"
              style={{ width: 40 }}
              onClick={() => {
                let currentlySelected = [...selectedPatients];

                let newSelected = patients
                  .map(p => p.user_id)
                  .filter(p => !currentlySelected.includes(p));

                if (newSelected.length == 0) {
                  setSelectedPatients([]);
                } else {
                  newSelected.map(i => {
                    if (selectedPatients.includes(i)) {
                      currentlySelected = currentlySelected.filter(
                        id => id !== i
                      );
                    } else {
                      currentlySelected = [...currentlySelected, i];
                    }
                  });
                  setSelectedPatients([...currentlySelected]);
                }
              }}
            />
          )
        },
        {
          header: "Name",
          field: "patient_name",
          Cell: () => <NonSortableHeader text="Name" />
        },
        {
          header: "Email",
          field: "patient_email",
          Cell: () => (
            <NonSortableHeader text="Email" style={{ maxWidth: 120 }} />
          ),
          style: { width: 120, maxWidth: 120 }
        },
        {
          header: "Date Of Birth",
          field: "date_of_birth",
          Cell: () => <NonSortableHeader text="Date Of Birth" />
        },
        {
          header: "Account Number",
          field: "account_number",
          Cell: () => <NonSortableHeader text="Account Number" />
        },
        {
          header: "Company",
          field: "company_name",
          Cell: () => <NonSortableHeader text="Company" />
        }
      ]}
      query={query}
      perPageOptions={[{ text: "50", value: 50 }]}
      pagination={{ page: 1, per: 50 }}
      queryDispatcher={queryDispatcher}
      rows={patients}
      rowKey="user_id"
      count={count}
    />
  );
};

export default PatientSearchResults;

PatientSearchResults.propTypes = {
  patients: PropTypes.arrayOf(PropTypes.object),
  isFetching: PropTypes.bool,
  selectedPatients: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  setSelectedPatients: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  pagination: PropTypes.shape({ page: PropTypes.number, per: PropTypes.number }),
  setPagination: PropTypes.func,
  count: PropTypes.number
};
